import React from 'react'

const SIGN_STATUS = {
  0: '待生成',
  1: '待签署',
  2: '已作废',
  3: '生效中',
  4: '已失效'
}

export default [
  {
    title: '合同文件',
    dataIndex: 'contract',
    key: 'contract',
    render: (text, record) => {
      return (
        <a target="_blank" rel="noopener noreferrer" href={record.detail_url}>
          《{record.contract_title}》
        </a>
      )
    }
  },
  {
    title: '签署状态',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => {
      return SIGN_STATUS[record.status] || ''
    }
  },
  {
    title: '签署时间',
    dataIndex: 'sign_time',
    key: 'sign_time'
  },
  {
    title: '操作',
    dataIndex: 'sign',
    key: 'sign',
    render: (text, record) => {
      return record.status !== 3 ? (
        <a target="_blank" rel="noopener noreferrer" href={record.sign_url}>
          立即签署
        </a>
      ) : (
        <a target="_blank" rel="noopener noreferrer" href={record.download_url}>
          下载
        </a>
      )
    }
  }
]
